import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericService } from '../../commons/generic.service';
import { environment } from 'environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import { EnumConselho } from 'app/model/enumConselho';
import {CampanhasDto} from "../../components/campanhas/campanhas.dto";
import {CampanhasFormDto} from "../../components/campanhas/campanhasForm.dto";
import {AlterarCampanhaFormDto} from "../../components/campanhas/alterarCampanhaForm.dto";
import {Page} from "../../model/Paginacao/Page";
import { ParamentrosTextoCampanha } from "../../model/paramentrosTextoCampanha";


@Injectable()
export class CampanhasService extends GenericService {

    private path = environment.url + 'api/v1/campanha';

    constructor(http: HttpClient) {
        super(http);
    }

    getCampanhas(pagina: number, itens: number, ano: number = 2023, tipoCampanha: number = 0): Observable<Page<CampanhasDto>> {
        let params = new HttpParams()
            .set('pagina', pagina)
            .set('itens', itens)
            .set('ano', ano)
            .set('tipoCampanha', tipoCampanha);
        return this.http.get<Page<CampanhasDto>>(this.path+'/paginacao', {params});
    }

    salvarCampanha(campanha: CampanhasFormDto): Observable<CampanhasDto> {
      return this.http.post<CampanhasDto>(this.path, campanha);
    }

    atualizarCampanha(campanha: AlterarCampanhaFormDto, tipoCampanhaPesquisa): Observable<CampanhasDto> {
        return this.http.put<CampanhasDto>(this.path + `/${tipoCampanhaPesquisa}`, campanha);
    }

    deletarCampanha(id: number): Observable<any> {
        return this.http.delete<any>(this.path+'/'+id);
    }

    getCampanhaRecadVigente(): Observable<any> {
        return this.http.get<any>(this.path+'/obter-nome-campanha-recadastramento')
    }

    getCampanhaBensEValoresVigente(): Observable<any> {
        return this.http.get<any>(this.path+'/obter-nome-campanha-bens-valores')
    }

    getParamentrosDeTextoCampanha(): Observable<ParamentrosTextoCampanha> {
        return this.http.get<any>(this.path+'/obter-parametros-campanha-recadastramento')
    }

}
